import InstallPureKitTabs from "common/purekit/install/install";
import ImplementCustomPureKitSnippet from "snippets/purekit/custom-storage/implement";
import InitializeCustomPureKitSnippet from "snippets/purekit/custom-storage/initialize-custom";
import * as React from 'react';
export default {
  InstallPureKitTabs,
  ImplementCustomPureKitSnippet,
  InitializeCustomPureKitSnippet,
  React
};